module.exports = __webpack_public_path__ + "img/landing-fil-rouge.a75c3589.jpg";